import { createFileRoute } from "@tanstack/react-router";
import type {} from "@tanstack/react-start";
import { GonePage, goneHandler } from "@/lib/seo/gone";

// Retired: utility bill checker pages permanently removed (410 Gone).
export const Route = createFileRoute("/tools/sngpl-gas-bill-checker")({
  server: { handlers: { GET: goneHandler } },
  component: GonePage,
});
